import React, { useEffect, useState } from 'react';
import { Table, Button, Modal, message } from 'antd';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import BasePagination from '../../../components/pagination';
import NoticeColumns from './notice_column';

import { restApi } from '../../../apis';
//----------------------------------------------------------------------------------------------------
const NoticeTable = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [messageApi, contextHolder] = message.useMessage();
  const isBack = (location.state && location.state.isBack) || false;
  const [startNum, setStartNum] = useState(
    isBack ? location.state.startNum : 1
  );
  const [current, setCurrent] = useState(isBack ? location.state.current : -1);
  const [total, setTotal] = useState(isBack ? location.state.current : 0);
  const [sorts, setSorts] = useState(
    isBack
      ? location?.state?.sorts
      : {
          selected: 'announceDate',
          title: 'DESC', //desc
          announceDate: 'DESC',
        }
  );
  const [dataSource, setDataSource] = useState([]);
  const [open, setOpen] = useState({
    action: false,
    id: '',
  });

  // const loading = props.loading;
  const setLoading = props.setLoading;
  //----------------------------------------------------------------------------------------------------
  const initData = () => {
    //페이지가 변경되면 서버로 부터 데이터 가져오기
    // 로딩
    setLoading(true);
    //페이지가 변경되면 서버로 부터 데이터 가져오기
    (async (args) => {
      const params = {
        pageNum: current,
        orderBy: sorts?.selected || 'title',
        sort: sorts?.selected ? sorts[sorts?.selected] : 'ASC',
      };

      await restApi
        .get(`/admin/notification`, {
          params,
        })
        .then((res) => {
          const payload = res?.data?.payload;
          if (payload) {
            setTotal(payload.totalCount || 1);
            setDataSource(payload.notifications || []);
          }
        });

      setLoading(false);
    })();

    setTimeout(() => {
      setLoading(false);
    }, 5000);
  };
  //----------------------------------------------------------------------------------------------------
  useEffect(() => {
    // 1페이지 정보 가져오기
    if (!isBack) {
      setCurrent(1);
    }
  }, []);

  useEffect(() => {
    initData();
  }, [current]);

  //  정렬
  useEffect(() => {
    // console.log('---11-->', sorts);
  }, [sorts]);
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  const OnCellClick = (args) => {
    const uuid = args.id;
    navigate(`/notices/details/${uuid}`, {
      replace: true,
      state: {
        isBack: false,
        current,
        total,
        sorts,
        //----------------
        title: args?.title,
        content: args?.content,
        announceDate: args?.announceDate,
      },
    });
  };

  const OnDeleted = (args) => {
    setOpen((prev) => {
      return {
        action: true,
        id: args?.id || '',
      };
    });
  };

  const OnCopy = (args) => {
    // alert('111');
    // return;
    // 흐음 1.
    if (navigator?.clipboard) {
      // (IE는 사용 못하고, 크롬은 66버전 이상일때 사용 가능합니다.)
      navigator.clipboard
        .writeText(
          String(args.content)
            .replace(/<[^>]*>?/g, '')
            .trim()
        )
        .then(() => {
          messageApi.info('클립보드에 복사되었습니다.');
        })
        .catch(() => {
          messageApi.info('복사를 다시 시도해주세요.');
        });
    } else {
      if (!document.queryCommandSupported('copy')) {
        return messageApi.info('복사하기가 지원되지 않는 브라우저입니다.');
      }
    }
  };

  //----------------------------------------------------------------------------------------------------
  return (
    <div>
      {contextHolder}
      <Table
        columns={NoticeColumns({
          ...props,
          sorts,
          setSorts,
          OnCellClick,
          OnDeleted,
          OnCopy,
        })}
        dataSource={dataSource}
        pagination={false}
        // components={components}
        // loading={loading}
      />
      <BasePagination
        startNum={startNum}
        setStartNum={setStartNum}
        current={current}
        setCurrent={setCurrent}
        total={total}
        pageSize={10}
        {...props}
      />
      {/* ----------------------------------------------------------------------------------------------------------------------------------- */}
      <Modal
        title={
          <div
          // style={{
          //   background: 'rgba(168, 170, 174, 0.16)',
          // }}
          >
            알림
          </div>
        }
        open={open.action}
        centered
        closable={false} // Whether a close (x) button is visible on top right of the modal dialog or not
        footer={[
          <Button
            key="delete"
            type="primary"
            // loading={loading}
            onClick={async (e) => {
              if (String(open?.id).length) {
                messageApi.info('공지사항을 삭제하였습니다.');
                await restApi.delete(`/admin/notification/${open.id}`);

                // 화면초기화
                initData();

                setOpen((prev) => {
                  return {
                    action: false,
                    id: '',
                  };
                });
              }
            }}
            danger
          >
            {`삭제`}
          </Button>,
          <Button
            key="cancel"
            type="default"
            onClick={(e) => {
              setOpen((prev) => {
                return {
                  action: false,
                  id: '',
                };
              });
            }}
          >
            {`취소`}
          </Button>,
        ]}
      >
        <p>{`공지사항을 삭제하면 밸런스피터 어드민에서는 물론, 밸런스피터 앱 내 공지사항 리스트에서도 삭제됩니다. 한번 삭제한 공지사항은 복구가 불가능합니다. 정말 해당 공지사항을 삭제하시겠습니까? `}</p>
      </Modal>
    </div>
  );
};

export default NoticeTable;
